import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LoginPage from "./pages/Login/LoginPage";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import ModulePage from "./pages/Module/ModulePage";
import OrderDetailPage from "./pages/OrderDetail/OrderDetailPage";
import VendorDetailPage from "./pages/VendorDetail/VendorDetailPage";
import OutletDetailPage from "./pages/OutletDetail/OutletDetailPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import AdministratorFormPage from "./pages/AdministratorForm/AdministratorFormPage";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout/AppLayout";

const isAuthenticated = () => localStorage.getItem("token") !== null;

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          path="/admin"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated()}>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="orders" element={<ModulePage type="orders" />} />
          <Route path="orders/:orderNo" element={<OrderDetailPage />} />
          <Route path="cancellations" element={<ModulePage type="cancellations" />} />
          <Route path="vendors" element={<ModulePage type="vendors" />} />
          <Route path="vendors/create" element={<VendorDetailPage mode="create" />} />
          <Route path="vendors/:vendorId" element={<VendorDetailPage />} />
          <Route path="vendors/:vendorId/edit" element={<VendorDetailPage mode="edit" />} />
          <Route path="vendors/:vendorId/outlets/create" element={<OutletDetailPage mode="create" />} />
          <Route path="vendors/:vendorId/outlets/:outletId" element={<OutletDetailPage />} />
          <Route path="administrators" element={<ModulePage type="administrators" />} />
          <Route path="administrators/create" element={<AdministratorFormPage mode="create" />} />
          <Route path="administrators/:adminId/edit" element={<AdministratorFormPage mode="edit" />} />
          <Route path="settings" element={<ModulePage type="settings" />} />
          <Route path="reports" element={<ModulePage type="reports" />} />
          <Route path="profile" element={<ProfilePage />} />
        </Route>

        <Route
          path="*"
          element={isAuthenticated() ? <Navigate to="/admin" /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
}

export default App;
